import { _APIHandler } from "../utils/helper";

let baseUrl = "purchase_orders";
export const fetchPurchaseOrders = (queryParams) => _APIHandler.get(`${baseUrl}`, { params: queryParams });
export const fetchPurchaseOrder = (id) => _APIHandler.get(`${baseUrl}/${id}`);
export const raiseRFQPurchaseOrder = (data) => _APIHandler.post(`${baseUrl}/rfq`, data);
export const raiseSPPurchaseOrder = (data) => _APIHandler.post(`${baseUrl}/raiseSP`, data);
export const updatePOStatus = (id, data) => _APIHandler.put(`${baseUrl}/${id}/update_po_status`, data);